import InternalForm, { useForm, useWatch } from 'antd/es/form/Form';
import { ConfigContext } from '../config-provider';
import Item from './FormItem';
import ErrorList from './ErrorList';
import List from './FormList';
import { FormProvider } from './context';
import warning from 'antd/es/_util/warning';
import { FormProps, FormInstance } from 'antd/es/form/Form';
import React from 'react';
import AntdConfigProvider from 'antd/es/config-provider';
const BdInternalForm = (props, ref) => {
    const { prefixCls, ...otherProps } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('form', prefixCls);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', prefixCls), ...restContext },
        React.createElement(InternalForm, { prefixCls: classPrefix, ...otherProps })));
};
const Form = BdInternalForm;
Form.Item = Item;
Form.List = List;
Form.ErrorList = ErrorList;
Form.useForm = useForm;
Form.Provider = FormProvider;
Form.create = () => {
    if (process.env.NODE_ENV !== 'production')
        warning(false, 'Form', 'antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.');
};
export { useForm, List, useWatch };
// export default withConfigProvider(Form);
export default Form;
